import React from 'react';

const App = () => {
  return (
    <div className="flex justify-center">
      <a href="https://wa.works">
        <div className="bg-light-green pointer-cursor div_buttonSize flex-center">
          <div className="self-center">Find candidates</div>
        </div>
      </a>
    </div>
  );
}

export default App;